<div class="lum-c-alternate-ids">
  <mat-form-field class="example-chip-list w-100" appearance="outline">
    <mat-chip-list #chipList aria-label="Alternate id selection">
      <mat-chip
        *ngFor="let alternateId of formArray?.value; trackBy: trackByValue"
        class="lum-chip"
        [removable]="!readonly"
        (removed)="onRemoveAlternateId(alternateId)"
      >
        {{ alternateId }}
        <mat-icon *ngIf="!readonly" matChipRemove>cancel</mat-icon>
      </mat-chip>
      <input
        *ngIf="!readonly"
        placeholder="{{ placeholder }}"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="onAddAlternateId($event)"
      />
    </mat-chip-list>
  </mat-form-field>
</div> 